import React from "react";
import content from "../data/results/2022content.json";
import resultData from "../data/2022data.json";
import ResultsPage from "./ResultsPage";

const Results2022 = () => <ResultsPage content={content} resultData={resultData} />;

export default Results2022;
